import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "emp-card__header" }
const _hoisted_3 = { class: "emp-card__subtitle" }
const _hoisted_4 = { class: "emp-form-wrapper" }
const _hoisted_5 = { class: "emp-acc__title" }
const _hoisted_6 = { class: "emp-acc__title-text" }
const _hoisted_7 = { class: "emp-acc__panel" }
const _hoisted_8 = { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }
const _hoisted_9 = { class: "p-3" }
const _hoisted_10 = {
  key: 0,
  class: "alert alert-danger mb-3"
}
const _hoisted_11 = { style: {"padding":"15px"} }
const _hoisted_12 = { style: {"margin-bottom":"20px"} }
const _hoisted_13 = { style: {"display":"flex","gap":"10px","margin-top":"10px"} }
const _hoisted_14 = { style: {"display":"flex","gap":"10px","margin-top":"10px"} }
const _hoisted_15 = { style: {"margin-bottom":"20px"} }
const _hoisted_16 = { style: {"margin-bottom":"20px"} }
const _hoisted_17 = { style: {"text-align":"right","margin-top":"15px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxSimpleItem = _resolveComponent("DxSimpleItem")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxAccordion = _resolveComponent("DxAccordion")!
  const _component_DxGroupItem = _resolveComponent("DxGroupItem")!
  const _component_DxTab = _resolveComponent("DxTab")!
  const _component_DxTabbedItem = _resolveComponent("DxTabbedItem")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_DxTextBox = _resolveComponent("DxTextBox")!

  return (_openBlock(), _createElementBlock("div", {
    class: "emp-card",
    key: `emp-${_ctx.employeeId}`
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_DxButton, {
        class: "edit-icon-btn",
        onClick: _ctx.openEdit
      }, {
        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
          _createElementVNode("i", { class: "edit-icon" }, null, -1)
        ]))]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.employee?.Employee.Name || '—') + " " + _toDisplayString(_ctx.employee?.Employee.Surname || ''), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_DxAccordion, {
        class: "emp-acc",
        "data-source": _ctx.sections,
        multiple: false,
        "animation-enabled": true,
        "defer-rendering": false,
        "focus-state-enabled": false
      }, {
        title: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(data.title), 1),
            _cache[18] || (_cache[18] = _createElementVNode("span", {
              class: "emp-acc__chev",
              "aria-hidden": "true"
            }, null, -1))
          ])
        ]),
        item: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_DxForm, {
              "label-location": 'top',
              "col-count": 2,
              "col-count-by-screen": { xs: 1, sm: 2, md: 2 },
              "min-col-width": 220,
              "styling-mode": 'filled',
              class: "emp-form",
              "form-data": _ctx.employee
            }, {
              default: _withCtx(() => [
                (data.key === 'ident')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_DxSimpleItem, {
                        "data-field": "Employee.InternalCode",
                        label: { text: 'Cod intern' },
                        "editor-options": { readOnly: !_ctx.isEditing }
                      }, null, 8, ["editor-options"]),
                      _createVNode(_component_DxSimpleItem, {
                        "data-field": "Employee.Cnp",
                        label: { text: 'CNP' },
                        "editor-options": { readOnly: !_ctx.isEditing }
                      }, null, 8, ["editor-options"]),
                      _createVNode(_component_DxSimpleItem, {
                        "data-field": "Sex",
                        label: { text: 'Sex' },
                        "editor-options": { readOnly: !_ctx.isEditing }
                      }, null, 8, ["editor-options"]),
                      _createVNode(_component_DxSimpleItem, {
                        "data-field": "Employee.BornDate",
                        label: { text: 'Data Nașterii' },
                        "editor-type": "dxDateBox",
                        "editor-options": {
                                        type: 'date',
                                        displayFormat: 'dd MMM yyyy',
                                        readOnly: !_ctx.isEditing
                                    }
                      }, null, 8, ["editor-options"]),
                      _createVNode(_component_DxSimpleItem, {
                        "data-field": "Struct",
                        label: { text: 'Departament' },
                        "col-span": 2,
                        "editor-options": {
                                        readOnly: !_ctx.isEditing
                                    }
                      }, null, 8, ["editor-options"]),
                      _createVNode(_component_DxSimpleItem, {
                        "data-field": "EmpGroup",
                        label: { text: 'Grup Angajati' },
                        "editor-options": {
                                    readOnly: !_ctx.isEditing
                                },
                        "col-span": 2
                      }, null, 8, ["editor-options"])
                    ], 64))
                  : (data.key === 'idcard')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "DocIdentTip",
                          label: { text: 'Tip Act Identitate' },
                          "editor-options": {
                                        readOnly: !_ctx.isEditing,
                                    }
                        }, null, 8, ["editor-options"]),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "Employee.DocIdentSerie",
                          label: { text: 'Serie' },
                          "editor-options": { readOnly: !_ctx.isEditing }
                        }, null, 8, ["editor-options"]),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "Employee.DocIdentNo",
                          label: { text: 'Numar' },
                          "editor-options": { readOnly: !_ctx.isEditing }
                        }, null, 8, ["editor-options"]),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "Employee.DocIdentIssueDate",
                          "editor-type": "dxDateBox",
                          label: { text: 'Data Emiterii' },
                          "editor-options": { readOnly: !_ctx.isEditing, displayFormat: 'dd MMM yyyy' }
                        }, null, 8, ["editor-options"]),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "Employee.DocIdentIssuer",
                          label: { text: 'Emitent' },
                          "editor-options": { readOnly: !_ctx.isEditing }
                        }, null, 8, ["editor-options"]),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "Employee.DocIdentExpiryDate",
                          "editor-type": "dxDateBox",
                          label: { text: 'Data Expirare' },
                          "editor-options": { readOnly: !_ctx.isEditing, displayFormat: 'dd MMM yyyy' }
                        }, null, 8, ["editor-options"]),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "Localitate",
                          label: { text: 'Loc Naștere' },
                          "editor-options": {
                                    readOnly: !_ctx.isEditing,
                                }
                        }, null, 8, ["editor-options"]),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "Tara",
                          label: { text: 'Țara Naștere' },
                          "editor-options": {
                                    readOnly: !_ctx.isEditing,
                                }
                        }, null, 8, ["editor-options"]),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "Adresa",
                          label: { text: 'Adresa Domiciliu' },
                          "editor-options": {
                                    readOnly: !_ctx.isEditing,
                                },
                          "col-span": 2
                        }, null, 8, ["editor-options"])
                      ], 64))
                    : (data.key === 'diverse')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "Meserie",
                            label: { text: 'Meserie/Profesie*' },
                            "editor-options": {
                                        readOnly: !_ctx.isEditing,

                                    }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "Employee.NrCrtOrg",
                            label: { text: 'Nr. Crt. Organigrama' },
                            "editor-options": { readOnly: !_ctx.isEditing }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "Functie",
                            label: { text: 'Functie (Post)' },
                            "editor-options": {
                                    readOnly: !_ctx.isEditing,
                                }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "GrupaMunca",
                            label: { text: 'Grupa de Munca' },
                            "editor-options": {
                                        readOnly: !_ctx.isEditing,
                                    }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "Employee.FunctieDeBaza",
                            "editor-type": "dxSwitch",
                            label: { text: 'Funcție de bază' },
                            "editor-options": { readOnly: !_ctx.isEditing }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "Employee.Pensionar",
                            label: { text: 'Este Pensionar? ' },
                            "editor-options": { readOnly: !_ctx.isEditing },
                            "editor-type": "dxSwitch"
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "Employee.OreContract",
                            label: { text: 'Ore Contract' },
                            "editor-options": { readOnly: !_ctx.isEditing }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "Employee.ZileConc",
                            label: { text: 'Zile Concediu' },
                            "editor-options": { readOnly: !_ctx.isEditing }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "StudiesLevel",
                            label: { text: 'Nivel Studii' },
                            "editor-options": {
                                        readOnly: !_ctx.isEditing,
                                    }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "MrtStatus",
                            label: { text: 'Stare Civila' },
                            "editor-options": {
                                    readOnly: !_ctx.isEditing,

                                }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DrvLicense",
                            label: { text: 'Permis Auto' },
                            "editor-options": {
                                    readOnly: !_ctx.isEditing,

                                }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "Employee.Vechime",
                            label: { text: 'Vechime Calculat' },
                            "editor-options": { readOnly: !_ctx.isEditing }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "Employee.Observations",
                            label: { text: 'Observatii' },
                            "editor-options": { readOnly: !_ctx.isEditing },
                            "col-span": 2
                          }, null, 8, ["editor-options"])
                        ], 64))
                      : (data.key === 'revisal')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.TransferInRevisal",
                              "editor-type": "dxSwitch",
                              label: { text: 'Transfer In Revisal' },
                              "editor-options": { readOnly: !_ctx.isEditing }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.Apatrid",
                              label: { text: 'Apatrid' },
                              "editor-options": { readOnly: !_ctx.isEditing }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Nationalitate",
                              label: { text: 'Nationalitate' },
                              "editor-options": {
                                        readOnly: !_ctx.isEditing,
                                    }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.Mentiuni",
                              label: { text: 'Mentiuni' },
                              "editor-options": { readOnly: !_ctx.isEditing }
                            }, null, 8, ["editor-options"])
                          ], 64))
                        : (data.key === 'salariatStrain')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                              _createVNode(_component_DxSimpleItem, {
                                "data-field": "Employee.TipAutorizatie",
                                label: { text: 'Tip Autorizatie' },
                                "col-span": 2,
                                "editor-options": { readOnly: !_ctx.isEditing }
                              }, null, 8, ["editor-options"]),
                              _createVNode(_component_DxSimpleItem, {
                                "data-field": "Employee.DataInceputAutorizatie",
                                label: { text: 'Data Inceput Autorizatie' },
                                "editor-type": "dxDateBox",
                                "editor-options": {
                                        type: 'date',
                                        displayFormat: 'dd MMM yyyy',
                                        readOnly: _ctx.isReadonlyTipAuorizatie,
                                    }
                              }, null, 8, ["editor-options"]),
                              _createVNode(_component_DxSimpleItem, {
                                "data-field": "Employee.DataSfarsitAutorizatie",
                                label: { text: 'Data Sfarsit Autorizatie' },
                                "editor-type": "dxDateBox",
                                "editor-options": {
                                        type: 'date',
                                        displayFormat: 'dd MMM yyyy',
                                        readOnly: _ctx.isReadonlyTipAuorizatie,

                                    }
                              }, null, 8, ["editor-options"])
                            ], 64))
                          : (data.key === 'd112')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                _createVNode(_component_DxSimpleItem, {
                                  "data-field": "Employee.CasaSn",
                                  label: { text: 'Casa Asigurari Sanatate' },
                                  "editor-options": { readOnly: !_ctx.isEditing }
                                }, null, 8, ["editor-options"]),
                                _createVNode(_component_DxSimpleItem, {
                                  "data-field": "TipAsigurat",
                                  label: { text: 'Tip Asigurat(A, B)' },
                                  "editor-options": {
                                        readOnly: !_ctx.isEditing,

                                    }
                                }, null, 8, ["editor-options"]),
                                _createVNode(_component_DxSimpleItem, {
                                  "data-field": "AsigScu",
                                  "editor-options": {
                                    readOnly: !_ctx.isEditing,

                                },
                                  label: { text: 'Scutire plata impozit pe venit: tip persoana' },
                                  "col-span": 2
                                }, null, 8, ["editor-options"]),
                                _createVNode(_component_DxSimpleItem, {
                                  "data-field": "Employee.D112AsigCi",
                                  "editor-options": { readOnly: !_ctx.isEditing },
                                  "editor-type": "dxSwitch",
                                  label: { text: 'Asigurat pentru concedii si indemnizatii de asigurari sociale de sanatate' },
                                  "col-span": 2
                                }, null, 8, ["editor-options"]),
                                _createVNode(_component_DxSimpleItem, {
                                  "data-field": "Employee.D112AsigSo",
                                  "editor-options": { readOnly: !_ctx.isEditing },
                                  "editor-type": "dxSwitch",
                                  label: { text: 'Asigurat in sistemul de asigurari pt somaj' }
                                }, null, 8, ["editor-options"]),
                                _createVNode(_component_DxSimpleItem, {
                                  "data-field": "Employee.D112AsigExc",
                                  "editor-options": { readOnly: !_ctx.isEditing },
                                  "editor-type": "dxSwitch",
                                  label: { text: 'Persoana exceptatat de la plata CAS si CASS' }
                                }, null, 8, ["editor-options"])
                              ], 64))
                            : (data.key === 'card')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                  _createVNode(_component_DxSimpleItem, {
                                    "data-field": "Employee.CardSalary",
                                    label: { text: 'Are Card?' },
                                    "editor-options": { readOnly: !_ctx.isEditing },
                                    "editor-type": "dxSwitch"
                                  }, null, 8, ["editor-options"]),
                                  _createVNode(_component_DxSimpleItem, {
                                    "data-field": "Employee.CardNo",
                                    label: { text: 'Numar' },
                                    "editor-options": { readOnly: !_ctx.isEditing }
                                  }, null, 8, ["editor-options"]),
                                  _createVNode(_component_DxSimpleItem, {
                                    "data-field": "Employee.CardAccNo",
                                    label: { text: 'Cont' },
                                    "editor-options": { readOnly: !_ctx.isEditing }
                                  }, null, 8, ["editor-options"]),
                                  _createVNode(_component_DxSimpleItem, {
                                    "data-field": "Banca",
                                    label: { text: 'Banca' },
                                    "editor-options": { readOnly: !_ctx.isEditing }
                                  }, null, 8, ["editor-options"])
                                ], 64))
                              : (data.key === 'pontaj')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                    _createVNode(_component_DxSimpleItem, {
                                      "data-field": "Employee.PontajOraInceput",
                                      label: { text: 'Oră început program' },
                                      "editor-options": { readOnly: !_ctx.isEditing }
                                    }, null, 8, ["editor-options"]),
                                    _createVNode(_component_DxSimpleItem, {
                                      "data-field": "Employee.PontajPauzaMinute",
                                      "editor-options": { readOnly: !_ctx.isEditing },
                                      label: { text: 'Durată pauză de masă (minute)' }
                                    }, null, 8, ["editor-options"]),
                                    _createVNode(_component_DxSimpleItem, {
                                      "data-field": "Structura",
                                      label: { text: 'Vizibil pentru: ' },
                                      "editor-options": { readOnly: !_ctx.isEditing },
                                      "col-span": 2
                                    }, null, 8, ["editor-options"]),
                                    _createVNode(_component_DxSimpleItem, {
                                      "data-field": "Employee.PontajUsrId",
                                      "editor-type": "dxTextBox",
                                      label: { text: 'User ID - Sistem Pontaj' },
                                      "col-span": 2,
                                      "editor-options": { readOnly: !_ctx.isEditing }
                                    }, null, 8, ["editor-options"])
                                  ], 64))
                                : (data.key === 'CategorieBaza')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                      _createVNode(_component_DxSimpleItem, {
                                        "data-field": "Employee.SalBaza",
                                        label: { text: 'Salariu de baza' },
                                        "editor-options": { readOnly: !_ctx.isEditing }
                                      }, null, 8, ["editor-options"]),
                                      _createVNode(_component_DxSimpleItem, {
                                        "data-field": "Employee.DataInceputAutorizatie",
                                        "editor-options": { readOnly: !_ctx.isEditing },
                                        label: { text: 'Somer unic sustinator fam. monoparentala' }
                                      }, null, 8, ["editor-options"]),
                                      _createVNode(_component_DxSimpleItem, {
                                        "data-field": "Employee.DataInceputAutorizatie",
                                        "editor-options": { readOnly: !_ctx.isEditing },
                                        label: { text: 'Somer peste 45 ani ' }
                                      }, null, 8, ["editor-options"]),
                                      _createVNode(_component_DxSimpleItem, {
                                        "data-field": "Employee.DataInceputAutorizatie",
                                        "editor-options": { readOnly: !_ctx.isEditing },
                                        label: { text: 'Avans suma fixa ' }
                                      }, null, 8, ["editor-options"]),
                                      _createVNode(_component_DxSimpleItem, {
                                        "data-field": "Employee.DataInceputAutorizatie",
                                        "editor-options": { readOnly: !_ctx.isEditing },
                                        label: { text: 'Primeste bonuri de masa' }
                                      }, null, 8, ["editor-options"]),
                                      _createVNode(_component_DxSimpleItem, {
                                        "data-field": "Employee.DataInceputAutorizatie",
                                        "editor-options": { readOnly: !_ctx.isEditing },
                                        label: { text: 'Suma Spor Weekend' }
                                      }, null, 8, ["editor-options"]),
                                      _createVNode(_component_DxSimpleItem, {
                                        "data-field": "Employee.DataInceputAutorizatie",
                                        "editor-options": { readOnly: !_ctx.isEditing },
                                        label: { text: 'Calcul Contributii CAS, CASS la Sal Min' }
                                      }, null, 8, ["editor-options"]),
                                      _createVNode(_component_DxSimpleItem, {
                                        "data-field": "Employee.DataInceputAutorizatie",
                                        "editor-options": { readOnly: !_ctx.isEditing },
                                        label: { text: 'Motiv exceptare CAS, CASS Sal Min' }
                                      }, null, 8, ["editor-options"]),
                                      _createVNode(_component_DxSimpleItem, {
                                        "data-field": "Employee.DataInceputAutorizatie",
                                        "editor-options": { readOnly: !_ctx.isEditing },
                                        "col-span": 2,
                                        label: { text: 'Numar copii inscrisi invatamant(OG.16/2022-art.77.10b)-deducere supl.' }
                                      }, null, 8, ["editor-options"])
                                    ], 64))
                                  : (data.key === 'CategorieSomaj')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                                        _createVNode(_component_DxSimpleItem, {
                                          "data-field": "salBaza",
                                          label: { text: 'Conventie Grupare' },
                                          "col-span": 2,
                                          "editor-options": { readOnly: !_ctx.isEditing }
                                        }, null, 8, ["editor-options"]),
                                        _createVNode(_component_DxSimpleItem, {
                                          "data-field": "DataInceputAutorizatie",
                                          "editor-options": { readOnly: !_ctx.isEditing },
                                          label: { text: 'Conventie Somaj Data ' }
                                        }, null, 8, ["editor-options"]),
                                        _createVNode(_component_DxSimpleItem, {
                                          "data-field": "DataInceputAutorizatie",
                                          "editor-options": { readOnly: !_ctx.isEditing },
                                          "col-span": 2,
                                          label: { text: 'Conventie Somaj Nr ' }
                                        }, null, 8, ["editor-options"])
                                      ], 64))
                                    : (data.key === 'CategorieVenituri')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                                          _createVNode(_component_DxSimpleItem, {
                                            "data-field": "Employee.DataInceputAutorizatie",
                                            "col-span": 2,
                                            "editor-options": { readOnly: !_ctx.isEditing },
                                            label: { text: ' 8.4.0 Alte drepturi neimpozitabile, cf.art.76 alin.(4) din CF (necategorisite mai jos)****' }
                                          }, null, 8, ["editor-options"]),
                                          _createVNode(_component_DxSimpleItem, {
                                            "data-field": "Employee.DataInceputAutorizatie",
                                            "col-span": 2,
                                            "editor-options": { readOnly: !_ctx.isEditing },
                                            label: { text: ' 8.4.1 Indemnizatii de delegare neimpozitabile, cf.art.76 alin.(4) lit.h) din CF***' }
                                          }, null, 8, ["editor-options"]),
                                          _createVNode(_component_DxSimpleItem, {
                                            "data-field": "Employee.DataInceputAutorizatie",
                                            "col-span": 2,
                                            "editor-options": { readOnly: !_ctx.isEditing },
                                            label: { text: ' 8.4.2 Indemnizatii de detasare neimpozitabile, cf.art.76 alin.(4) lit.h) din CF****' }
                                          }, null, 8, ["editor-options"]),
                                          _createVNode(_component_DxSimpleItem, {
                                            "data-field": "Employee.DataInceputAutorizatie",
                                            "col-span": 2,
                                            "editor-options": { readOnly: !_ctx.isEditing },
                                            label: { text: ' 8.4.3 Indemnizatii specifice detasarii transnationale neimpozitabile, cf.art.76 alin.(4) lit.h) din CF****' }
                                          }, null, 8, ["editor-options"]),
                                          _createVNode(_component_DxSimpleItem, {
                                            "data-field": "Employee.DataInceputAutorizatie",
                                            "col-span": 2,
                                            "editor-options": { readOnly: !_ctx.isEditing },
                                            label: { text: ' 8.4.4 Prestatii suplimentare primite de salariati in baza clauzei de mobilitate neimpozabile, cf.art.76 alin.(2) si alin.(4) lit.a) din CF	****' }
                                          }, null, 8, ["editor-options"]),
                                          _createVNode(_component_DxSimpleItem, {
                                            "data-field": "Employee.DataInceputAutorizatie",
                                            "col-span": 2,
                                            "editor-options": { readOnly: !_ctx.isEditing },
                                            label: { text: ' 8.4.5 Avantajele sub forma dreptului la stock options plan, la momentul acordarii si la momentul exercitarii acestora, cf.art.76 alin.(4) lit.r) din CF	****' }
                                          }, null, 8, ["editor-options"]),
                                          _createVNode(_component_DxSimpleItem, {
                                            "data-field": "Employee.DataInceputAutorizatie",
                                            "col-span": 2,
                                            "editor-options": { readOnly: !_ctx.isEditing },
                                            label: { text: ' 8.4.6 Contributiile la un fond de pensii facultative(L.204/2006), suportate de angajator pentru angajatii proprii, in limita a 400 euro/an/persoana, cf.art.76alin.(4^1) lit.e) din CF	****' }
                                          }, null, 8, ["editor-options"]),
                                          _createVNode(_component_DxSimpleItem, {
                                            "data-field": "Employee.DataInceputAutorizatie",
                                            "col-span": 2,
                                            "editor-options": { readOnly: !_ctx.isEditing },
                                            label: { text: ' 8.4.7 Primele de asigurare voluntara de sanatate precum si serviciile medicale furnizate sub forma de abonament, suportate de angajator pentru angajatii proprii, in limita a 400 euro/an/persoana, cf.art.76 alin.(4^1) lit.f) din CF	****' }
                                          }, null, 8, ["editor-options"]),
                                          _createVNode(_component_DxSimpleItem, {
                                            "data-field": "Employee.DataInceputAutorizatie",
                                            "col-span": 2,
                                            "editor-options": { readOnly: !_ctx.isEditing },
                                            label: { text: ' 8.4.8 C/val serv. turistice si/sau de tratament (+transportul), pe perioada CO, acordate de angajator pentru salariatii proprii, cf. CIM sau in regulamentul intern, cf.art.76 alin.(4^1) lit.d) din CF	****' }
                                          }, null, 8, ["editor-options"]),
                                          _createVNode(_component_DxSimpleItem, {
                                            "data-field": "Employee.DataInceputAutorizatie",
                                            "col-span": 2,
                                            "editor-options": { readOnly: !_ctx.isEditing },
                                            label: { text: ' 8.4.9 C/val ab. pentru utilizarea facilitatilor sportive, suportate de angajator, in limita a 400 euro/an/persoana, cf.art. 76 alin. 4^1 lit. h) din CF	****' }
                                          }, null, 8, ["editor-options"]),
                                          _createVNode(_component_DxSimpleItem, {
                                            "data-field": "Employee.DataInceputAutorizatie",
                                            "col-span": 2,
                                            "editor-options": { readOnly: !_ctx.isEditing },
                                            label: { text: ' 8.4.10 C/val hranei acordate de catre angajator pentru angajatii proprii, cf. art. 76 alin. 4^1 lit. b) din CF	****' }
                                          }, null, 8, ["editor-options"]),
                                          _createVNode(_component_DxSimpleItem, {
                                            "data-field": "Employee.DataInceputAutorizatie",
                                            "col-span": 2,
                                            "editor-options": { readOnly: !_ctx.isEditing },
                                            label: { text: ' 8.4.11 Cazarea si contravaloarea chiriei pentru spatiile de cazare/de locuit puse de catre angajatori la dispozitia angajatilor propriii, cf. art.76 alin. 4^1 lit. c) din CF	****' }
                                          }, null, 8, ["editor-options"]),
                                          _createVNode(_component_DxSimpleItem, {
                                            "data-field": "Employee.DataInceputAutorizatie",
                                            "col-span": 2,
                                            "editor-options": { readOnly: !_ctx.isEditing },
                                            label: { text: ' 8.4.12 Sumele acordate angajatilor care desfasoara activitati in regim de telemunca, cf. art. 76 alin.4^1 lit. g) din CF		****' }
                                          }, null, 8, ["editor-options"])
                                        ], 64))
                                      : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["form-data"])
          ])
        ]),
        _: 1
      }, 8, ["data-source"]),
      _createVNode(_component_DxPopup, {
        visible: _ctx.popupVisible,
        "show-title": true,
        "drag-enabled": true,
        "close-on-outside-click": false,
        width: 800,
        height: 620
      }, {
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, " Editare - " + _toDisplayString(_ctx.employee?.Employee.Name || '—') + " " + _toDisplayString(_ctx.employee?.Employee.Surname || ''), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            (_ctx.errorText)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.errorText), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_DxForm, {
              ref: "editFormRef",
              "form-data": _ctx.employee,
              "styling-mode": "filled",
              "read-only": _ctx.isSaving
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxTabbedItem, {
                  "tab-panel-options": _ctx.tabPanelOptions,
                  "css-class": "tabs-two-rows"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxTab, {
                      title: _ctx.tabs[0]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxGroupItem, { "col-count": 3 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.InternalCode",
                              label: { text: 'Cod intern' },
                              "is-required": true
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.Name",
                              label: { text: 'Nume' },
                              "is-required": true
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.Surname",
                              label: { text: 'Prenume' },
                              "is-required": true
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.Cnp",
                              label: { text: 'CNP' },
                              "is-required": true,
                              "editor-type": "dxTextBox",
                              "editor-options": {
                                            mask: '0000000000000',
                                            useMaskedValue: true,
                                            onValueChanged: _ctx.onCnpChanged
                                        }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.Sex",
                              label: { text: 'Sex' },
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                            dataSource: _ctx.dsGetAll?.Sex ?? [],
                                            valueExpr: 'cod',
                                            displayExpr: 'nume',
                                            showClearButton: true,
                                            searchEnabled: true,

                                        },
                              "is-required": true
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.BornDate",
                              "editor-type": "dxDateBox",
                              "is-required": true,
                              label: { text: 'Data Nașterii' },
                              "editor-options": { type: 'date', displayFormat: 'dd MMM yyyy' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.EmpgroupId",
                              label: { text: 'Grup Angajati' },
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                            dataSource: _ctx.dsGetAll?.GrupaAngajati ?? [],
                                            valueExpr: 'ID',
                                            displayExpr: 'Nume',
                                            showClearButton: true,
                                            searchEnabled: true,
                                        },
                              "is-required": true
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.StructId",
                              label: { text: 'Departament' },
                              "col-span": 2,
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                            dataSource: _ctx.dsStructuri,
                                            valueExpr: 'ID',
                                            displayExpr: 'Name',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează',

                                        },
                              "is-required": true
                            }, null, 8, ["editor-options"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    _createVNode(_component_DxTab, {
                      title: _ctx.tabs[1]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxGroupItem, { "col-count": 3 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DocIdentTip",
                              label: { text: 'Tip Act Identitate' },
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                            dataSource: _ctx.dsGetAll?.DocIdentTip ?? [],
                                            valueExpr: 'cod',
                                            displayExpr: 'nume',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Carte Identitate'
                                        }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DocIdentSerie",
                              label: { text: 'Serie' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DocIdentNo",
                              label: { text: 'Numar' },
                              "editor-type": "dxTextBox",
                              "editor-options": {
                                            mask: '000000',
                                            useMaskedValue: true,

                                        }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DocIdentIssuer",
                              label: { text: 'Emitent' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DocIdentIssueDate",
                              "editor-type": "dxDateBox",
                              label: { text: 'Data Emiterii' },
                              "editor-options": {
                                            displayFormat: 'dd MMM yyyy',
                                            onValueChanged(e) {
                                                _ctx.employee.Employee.DocIdentIssueDate = e.value;
                                            }
                                        }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DocIdentExpiryDate",
                              "editor-type": "dxDateBox",
                              label: { text: 'Data Expirare' },
                              "editor-options": {
                                            displayFormat: 'dd MMM yyyy',
                                            min: _ctx.expiryMinDate
                                        }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.BornCntryId",
                              label: { text: 'Țara' },
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                            dataSource: _ctx.dsGetAll?.Tari ?? [],
                                            valueExpr: 'ID',
                                            displayExpr: 'Nume',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează',

                                        }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              label: { text: 'Localitate' },
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                            dataSource: _ctx.dsLocalitati ?? [],
                                            valueExpr: 'ID',
                                            displayExpr(item) { return item ? `${item.CodSiruta}/Jud. ${item.Judet}/ ${item.Localitate}/ ${item.Sat}` : `` },
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează',
                                            value: _ctx.employee.Employee.BornPlaceId,

                                            onValueChanged: (e) => {
                                                _ctx.employee.Employee.BornPlaceId = e.value;
                                            },

                                        },
                              "col-span": 2
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "col-span": 3,
                              label: { text: 'Adresa Domiciliu' },
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                            dataSource: _ctx.dsAdrese,
                                            valueExpr: 'ID',
                                            displayExpr: 'Adresa1',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează',

                                            value: _ctx.employee.Employee.AddressId,

                                            onValueChanged: (e) => {
                                                _ctx.employee.Employee.AddressId = e.value;
                                            },

                                            onOpened: (e) => {
                                                e.component.close();
                                                _ctx.popupAdreseVisible = true;
                                                _ctx.openAddressPopup();
                                            }
                                        }
                            }, null, 8, ["editor-options"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    _createVNode(_component_DxTab, {
                      title: _ctx.tabs[2]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxGroupItem, { "col-count": 3 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxSimpleItem, {
                              label: { text: 'Meserie/Profesie*' },
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                            dataSource: _ctx.dsMeserii ?? [],
                                            valueExpr: 'ID',
                                            displayExpr(item) { return item ? `${item.code}/${item.name}` : `` },
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează',
                                            value: _ctx.employee.Employee.MeserieId,

                                            onValueChanged: (e) => {
                                                _ctx.employee.Employee.MeserieId = e.value;
                                            },
                                        }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.NrCrtOrg",
                              label: { text: 'Nr. Crt. Organigrama' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.PositionId",
                              label: { text: 'Funcție (Post)' },
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                            dataSource: _ctx.dsGetAll?.Post ?? [],
                                            valueExpr: 'ID',
                                            displayExpr: 'name',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează'
                                        }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.WorkGrade",
                              label: { text: 'Grupa de Muncă' },
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                            dataSource: _ctx.dsGetAll?.WorkGrade ?? [],
                                            valueExpr: 'cod',
                                            displayExpr: 'nume',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează'
                                        }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.FunctieDeBaza",
                              "editor-type": "dxSwitch",
                              label: { text: 'Funcție de bază' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.Pensionar",
                              label: { text: 'Este Pensionar? ' },
                              "editor-type": "dxSwitch"
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.OreContract",
                              label: { text: 'Ore Contract' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.ZileConc",
                              label: { text: 'Zile Concediu' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.StudiesLevel",
                              label: { text: 'Nivel Studii' },
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                            dataSource: _ctx.dsGetAll?.StudiesLevel ?? [],
                                            valueExpr: 'cod',
                                            displayExpr: 'nume',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează'
                                        }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.MrtStatus",
                              label: { text: 'Stare Civila' },
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                            dataSource: _ctx.dsGetAll?.Mrt ?? [],
                                            valueExpr: 'cod',
                                            displayExpr: 'nume',
                                            showClearButton: true,
                                            searchEnabled: true,

                                        }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DrvLicense",
                              label: { text: 'Permis Auto' },
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                            dataSource: _ctx.dsGetAll?.DrvLicense ?? [],
                                            valueExpr: 'cod',
                                            displayExpr: 'nume',
                                            showClearButton: true,
                                            searchEnabled: true,

                                        }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.Vechime",
                              label: { text: 'Vechime Calculat' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.Observations",
                              label: { text: 'Observatii' },
                              "col-span": 3
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    _createVNode(_component_DxTab, {
                      title: _ctx.tabs[3]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxGroupItem, { "col-count": 2 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.TransferInRevisal",
                              "editor-type": "dxSwitch",
                              label: { text: 'Transfer In Revisal' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.Apatrid",
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                            dataSource: _ctx.dsGetAll?.Apatrid ?? [],
                                            valueExpr: 'cod',
                                            displayExpr: 'nume',
                                            showClearButton: true,
                                            searchEnabled: true,

                                        }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              label: { text: 'Nationalitate' },
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                            dataSource: _ctx.dsNationalitati ?? [],
                                            valueExpr: 'ID',
                                            displayExpr: 'Nume',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează',
                                            value: _ctx.employee.Employee.TaraNationalitateId,

                                            onValueChanged: (e) => {
                                                _ctx.employee.Employee.TaraNationalitateId = e.value;
                                            },
                                        }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.Mentiuni",
                              label: { text: 'Mentiuni' }
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    _createVNode(_component_DxTab, {
                      title: _ctx.tabs[4],
                      disabled: _ctx.detaliiStrainDisabled
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxGroupItem, { "col-count": 2 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.TipAutorizatie",
                              label: { text: 'Tip Autorizatie' },
                              "col-span": 2,
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                            dataSource: _ctx.dsGetAll?.TipAutorizatie ?? [],
                                            valueExpr: 'cod',
                                            displayExpr: 'nume',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează'
                                        }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              "editor-type": "dxDateBox",
                              label: { text: 'Data Inceput Autorizatie' },
                              "editor-options": {
                                            displayFormat: 'dd MMM yyyy',

                                            onValueChanged(e) {
                                                _ctx.employee.Employee.DataInceputAutorizatie = e.value;
                                            }
                                        }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataSfarsitAutorizatie",
                              "editor-type": "dxDateBox",
                              label: { text: 'Data Sfarsit Autorizatie' },
                              "editor-options": {
                                            displayFormat: 'dd MMM yyyy',
                                            min: _ctx.expiryDate,

                                        }
                            }, null, 8, ["editor-options"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title", "disabled"]),
                    _createVNode(_component_DxTab, {
                      title: _ctx.tabs[5]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxGroupItem, { "col-count": 2 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.CasaSn",
                              label: { text: 'Casa Asigurari Sanatate' },
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                            dataSource: _ctx.dsGetAll?.CasaSn ?? [],
                                            valueExpr: 'cod',
                                            displayExpr: 'nume',
                                            showClearButton: true,
                                            searchEnabled: true,


                                        }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "D112TipAsigurat",
                              label: { text: 'Tip Asigurat(A, B)' },
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                            dataSource: _ctx.dsGetAll?.D112_TipAsigurat ?? [],
                                            valueExpr: 'cod',
                                            displayExpr: 'nume',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            onValueChanged(e) {
                                                _ctx.employee.Employee.D112TipAsigurat = e.value;
                                            }

                                        }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "D112AsigScu",
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                        dataSource: _ctx.dsGetAll?.D112_AsigScu ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        onValueChanged(e) {
                                            _ctx.employee.Employee.D112AsigScu = e.value;
                                        }

                                    },
                              label: { text: 'Scutire plata impozit pe venit: tip persoana' },
                              "col-span": 2
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.D112AsigCi",
                              "editor-type": "dxSwitch",
                              label: { text: 'Asigurat pentru concedii si indemnizatii de asigurari sociale de sanatate' },
                              "col-span": 2
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.D112AsigSo",
                              "editor-type": "dxSwitch",
                              label: { text: 'Asigurat in sistemul de asigurari pt somaj' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.D112AsigExc",
                              "editor-type": "dxSwitch",
                              label: { text: 'Persoana exceptatat de la plata CAS si CASS' }
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    _createVNode(_component_DxTab, {
                      title: _ctx.tabs[6]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxGroupItem, { "col-count": 2 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.CardSalary",
                              label: { text: 'Are Card?' },
                              "editor-type": "dxSwitch"
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.CardNo",
                              label: { text: 'Numar' },
                              "editor-options": {
                                            mask: '0000000000000000',
                                            useMaskedValue: true,
                                            readOnly: _ctx.isReadonly
                                        }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.CardBankId",
                              label: { text: 'Banca' },
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                            dataSource: _ctx.dsGetAll?.Banca ?? [],
                                            valueExpr: 'ID',
                                            displayExpr: 'Nume',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează'
                                        }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.CardAccNo",
                              label: { text: 'Cont' }
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    _createVNode(_component_DxTab, {
                      title: _ctx.tabs[7]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxGroupItem, { "col-count": 3 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.PontajOraInceput",
                              label: { text: 'Oră început program' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.PontajPauzaMinute",
                              label: { text: 'Durată pauză de masă (minute)' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.StructuraId",
                              label: { text: 'Vizibil pentru: ' },
                              "editor-type": "dxSelectBox",
                              "editor-options": {
                                            dataSource: _ctx.dsGetAll?.Structura ?? [],
                                            valueExpr: 'Id',
                                            displayExpr: 'Nume',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează',
                                        }
                            }, null, 8, ["editor-options"]),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.PontajUsrId",
                              "editor-type": "dxTextBox",
                              label: { text: 'User ID - Sistem Pontaj' },
                              "col-span": 3
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    _createVNode(_component_DxTab, {
                      title: _ctx.tabs[8]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxGroupItem, { "col-count": 2 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.SalBaza",
                              label: { text: 'Salariu de baza' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              label: { text: 'Somer unic sustinator fam. monoparentala' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              label: { text: 'Somer peste 45 ani ' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              label: { text: 'Avans suma fixa ' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              label: { text: 'Primeste bonuri de masa' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              label: { text: 'Suma Spor Weekend' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              label: { text: 'Calcul Contributii CAS, CASS la Sal Min' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              label: { text: 'Motiv exceptare CAS, CASS Sal Min' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              "col-span": 2,
                              label: { text: 'Numar copii inscrisi invatamant(OG.16/2022-art.77.10b)-deducere supl.' }
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    _createVNode(_component_DxTab, {
                      title: _ctx.tabs[9]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxGroupItem, { "col-count": 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "salBaza",
                              label: { text: 'Conventie Grupare' },
                              "col-span": 2
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "DataInceputAutorizatie",
                              label: { text: 'Conventie Somaj Data ' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "DataInceputAutorizatie",
                              "col-span": 2,
                              label: { text: 'Conventie Somaj Nr ' }
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    _createVNode(_component_DxTab, {
                      title: _ctx.tabs[10]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxGroupItem, { "col-count": 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              "col-span": 2,
                              label: { text: ' 8.4.0 Alte drepturi neimpozitabile, cf.art.76 alin.(4) din CF (necategorisite mai jos)****' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              "col-span": 2,
                              label: { text: ' 8.4.1 Indemnizatii de delegare neimpozitabile, cf.art.76 alin.(4) lit.h) din CF***' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              "col-span": 2,
                              label: { text: ' 8.4.2 Indemnizatii de detasare neimpozitabile, cf.art.76 alin.(4) lit.h) din CF****' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              "col-span": 2,
                              label: { text: ' 8.4.3 Indemnizatii specifice detasarii transnationale neimpozitabile, cf.art.76 alin.(4) lit.h) din CF****' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              "col-span": 2,
                              label: { text: ' 8.4.4 Prestatii suplimentare primite de salariati in baza clauzei de mobilitate neimpozabile, cf.art.76 alin.(2) si alin.(4) lit.a) din CF	****' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              "col-span": 2,
                              label: { text: ' 8.4.5 Avantajele sub forma dreptului la stock options plan, la momentul acordarii si la momentul exercitarii acestora, cf.art.76 alin.(4) lit.r) din CF	****' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              "col-span": 2,
                              label: { text: ' 8.4.6 Contributiile la un fond de pensii facultative(L.204/2006), suportate de angajator pentru angajatii proprii, in limita a 400 euro/an/persoana, cf.art.76alin.(4^1) lit.e) din CF	****' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              "col-span": 2,
                              label: { text: ' 8.4.7 Primele de asigurare voluntara de sanatate precum si serviciile medicale furnizate sub forma de abonament, suportate de angajator pentru angajatii proprii, in limita a 400 euro/an/persoana, cf.art.76 alin.(4^1) lit.f) din CF	****' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              "col-span": 2,
                              label: { text: ' 8.4.8 C/val serv. turistice si/sau de tratament (+transportul), pe perioada CO, acordate de angajator pentru salariatii proprii, cf. CIM sau in regulamentul intern, cf.art.76 alin.(4^1) lit.d) din CF	****' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              "col-span": 2,
                              label: { text: ' 8.4.9 C/val ab. pentru utilizarea facilitatilor sportive, suportate de angajator, in limita a 400 euro/an/persoana, cf.art. 76 alin. 4^1 lit. h) din CF	****' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              "col-span": 2,
                              label: { text: ' 8.4.10 C/val hranei acordate de catre angajator pentru angajatii proprii, cf. art. 76 alin. 4^1 lit. b) din CF	****' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              "col-span": 2,
                              label: { text: ' 8.4.11 Cazarea si contravaloarea chiriei pentru spatiile de cazare/de locuit puse de catre angajatori la dispozitia angajatilor propriii, cf. art.76 alin. 4^1 lit. c) din CF	****' }
                            }),
                            _createVNode(_component_DxSimpleItem, {
                              "data-field": "Employee.DataInceputAutorizatie",
                              "col-span": 2,
                              label: { text: ' 8.4.12 Sumele acordate angajatilor care desfasoara activitati in regim de telemunca, cf. art. 76 alin.4^1 lit. g) din CF		****' }
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"])
                  ]),
                  _: 1
                }, 8, ["tab-panel-options"])
              ]),
              _: 1
            }, 8, ["form-data", "read-only"])
          ]),
          _createVNode(_component_DxToolbarItem, {
            toolbar: "bottom",
            location: "after",
            widget: 'dxButton',
            options: {
                    text: 'Salvează',
                    type: 'success',
                    stylingMode: 'contained',
                    onClick: _ctx.submitForm,
                    width: 110,
                    height: 32,
                    elementAttr: { class: 'mb-2' }
                }
          }, null, 8, ["options"]),
          _createVNode(_component_DxToolbarItem, {
            toolbar: "bottom",
            location: "after",
            widget: 'dxButton',
            options: {
                    text: 'Închide',
                    type: 'danger',
                    stylingMode: 'contained',
                    onClick: _ctx.closePopup,
                    width: 110,
                    height: 32,
                    elementAttr: { class: 'mb-2' }
                }
          }, null, 8, ["options"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_DxPopup, {
        visible: _ctx.popupAdreseVisible,
        "show-title": true,
        title: "Selectare adresa",
        width: 840,
        height: 680,
        onHiding: _cache[16] || (_cache[16] = ($event: any) => (_ctx.popupAdreseVisible = false))
      }, {
        title: _withCtx(() => [...(_cache[19] || (_cache[19] = [
          _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Selectează adresa ", -1)
        ]))]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[20] || (_cache[20] = _createElementVNode("h4", { style: {"font-weight":"800","margin-bottom":"10px","border-bottom":"2px solid #ff2c21","padding-bottom":"6px","color":"#ff2c21"} }, " Adresa ", -1)),
              _createVNode(_component_DxSelectBox, {
                "data-source": _ctx.dsGetAll?.TipAdresa,
                "display-expr": "nume",
                "value-expr": "cod",
                placeholder: "Tip",
                "search-enabled": true,
                value: _ctx.dataAdress.TipCod,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dataAdress.TipCod) = $event))
              }, null, 8, ["data-source", "value"]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_DxTextBox, {
                  placeholder: "Strada",
                  style: {"margin-top":"10px","flex":"2"},
                  value: _ctx.dataAdress.Strada,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataAdress.Strada) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_DxTextBox, {
                  placeholder: "StradaNr",
                  style: {"margin-top":"10px","flex":"1"},
                  value: _ctx.dataAdress.StradaNr,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataAdress.StradaNr) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_DxTextBox, {
                  placeholder: "Bloc",
                  style: {"margin-top":"10px","flex":"1"},
                  value: _ctx.dataAdress.Bloc,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataAdress.Bloc) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_DxTextBox, {
                  placeholder: "Scara",
                  style: {"margin-top":"10px","flex":"1"},
                  value: _ctx.dataAdress.Scara,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataAdress.Scara) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_DxTextBox, {
                  placeholder: "Etaj",
                  style: {"margin-top":"10px","flex":"1"},
                  value: _ctx.dataAdress.Etaj,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataAdress.Etaj) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_DxTextBox, {
                  placeholder: "Apartament",
                  style: {"margin-top":"10px","flex":"2"},
                  value: _ctx.dataAdress.Apartament,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dataAdress.Apartament) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_DxTextBox, {
                  placeholder: "CodPostal",
                  style: {"margin-top":"10px","flex":"2"},
                  value: _ctx.dataAdress.CodPostal,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dataAdress.CodPostal) = $event))
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_DxSelectBox, {
                  "data-source": _ctx.dsTari,
                  "display-expr": "Nume",
                  "value-expr": "ID",
                  placeholder: "Țara",
                  "search-enabled": true,
                  value: _ctx.dataAdress.TaraID,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dataAdress.TaraID) = $event)),
                  onValueChanged: _ctx.onTaraChanged
                }, null, 8, ["data-source", "value", "onValueChanged"]),
                _createVNode(_component_DxSelectBox, {
                  "data-source": _ctx.dsJudete,
                  "display-expr": "Nume",
                  "value-expr": "ID",
                  placeholder: "Județ",
                  "search-enabled": true,
                  value: _ctx.dataAdress.JudetID,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dataAdress.JudetID) = $event)),
                  onValueChanged: _ctx.onJudetChanged,
                  disabled: !_ctx.dataAdress.TaraID
                }, null, 8, ["data-source", "value", "onValueChanged", "disabled"]),
                _createVNode(_component_DxSelectBox, {
                  "data-source": _ctx.dsLocalitati,
                  "display-expr": "Localitate",
                  "value-expr": "ID",
                  placeholder: "Localitate",
                  "search-enabled": true,
                  value: _ctx.localitateId,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.localitateId) = $event)),
                  onValueChanged: _ctx.onLocalitateChanged,
                  disabled: !_ctx.dataAdress.JudetID
                }, null, 8, ["data-source", "value", "onValueChanged", "disabled"]),
                _createVNode(_component_DxSelectBox, {
                  "data-source": _ctx.dsLocalitati,
                  "display-expr": "Sat",
                  "value-expr": "ID",
                  placeholder: "Sat",
                  "search-enabled": true,
                  value: _ctx.satId,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.satId) = $event)),
                  onValueChanged: _ctx.onSatChanged,
                  disabled: !_ctx.localitateId
                }, null, 8, ["data-source", "value", "onValueChanged", "disabled"])
              ]),
              _createVNode(_component_DxTextBox, {
                placeholder: "Cod SIRUTA",
                style: {"margin-top":"10px"},
                value: _ctx.codSiruta,
                "read-only": true
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[21] || (_cache[21] = _createElementVNode("h4", { style: {"font-weight":"800","margin-bottom":"10px","border-bottom":"2px solid #ff2c21","padding-bottom":"6px","color":"#ff2c21"} }, " Profesional ", -1)),
              _createVNode(_component_DxTextBox, {
                placeholder: "Telefon",
                value: _ctx.dataAdress.Telefon,
                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dataAdress.Telefon) = $event)),
                "show-spin-buttons": false,
                "show-clear-button": true,
                min: 0,
                format: '#0'
              }, null, 8, ["value"]),
              _createVNode(_component_DxTextBox, {
                placeholder: "Email (acces Portal HR)",
                style: {"margin-top":"10px"},
                value: _ctx.dataAdress.Email,
                "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.dataAdress.Email) = $event))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[22] || (_cache[22] = _createElementVNode("h4", { style: {"font-weight":"800","margin-bottom":"10px","border-bottom":"2px solid #ff2c21","padding-bottom":"6px","color":"#ff2c21"} }, " Personal ", -1)),
              _createVNode(_component_DxTextBox, {
                placeholder: "Telefon",
                value: _ctx.dataAdress.TelefonPersonal,
                "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dataAdress.TelefonPersonal) = $event)),
                "show-spin-buttons": false,
                "show-clear-button": true,
                min: 0,
                format: '#0'
              }, null, 8, ["value"]),
              _createVNode(_component_DxTextBox, {
                placeholder: "Email",
                style: {"margin-top":"10px"},
                value: _ctx.dataAdress.EmailPersonal,
                "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.dataAdress.EmailPersonal) = $event))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_DxButton, {
                text: "Aplică",
                type: "default",
                style: {"height":"32px","font-size":"13px","padding":"2px 10px","width":"110px","margin-right":"10px"},
                onClick: _ctx.applyAddress
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                type: "danger",
                style: {"height":"32px","font-size":"13px","padding":"2px 10px","width":"110px"},
                onClick: _ctx.closePopupAdrese
              }, null, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}